export const PAGE_VIEW_URL_CONFIG_OPTIONS = {
  FULL_URL: 'full-url',
  URL_WITH_PATH_AND_QUERY_STRING: 'url-with-path-and-query-string',
  URL_WITH_PATH: 'url-with-path'
} as const

export const PERSISTENCE_OPTIONS = {
  LOCAL_STORAGE: 'localStorage',
  COOKIE: 'cookie'
} as const

export const AUTOCAPTURE_OPTIONS = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  CUSTOM: 'custom'
} as const

export const STANDARD_USER_PROFILE_PROPERTIES = [
  'name',
  'first_name',
  'last_name',
  'email',
  'phone',
  'avatar',
  'created'
] as readonly string[]